import React, { useRef, useState, useEffect } from "react";

import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import utf8 from "utf8";
import { tokenProcessingTest } from "../TokenProcessing/TokenProcessing";
import { AxiosRequest, XMLrequest } from "../Url";
import TextEditor from "./TextEditor";
import smetaAxios from "../SmetaAxios";

export const htmlToMime = (textValue) => {
  if (textValue === "")
    return 'MIME-Version: 1.0\r\nContent-Type: multipart/related; boundary="----=_BOUNDARY_LINE_"\r\n\r\n------=_BOUNDARY_LINE_\r\nContent-Type: text/html; charset="utf-8"\r\nContent-Transfer-Encoding: base64\r\n\r\n \r\n\r\n------=_BOUNDARY_LINE_--\r\n';
  let str = textValue;
  let result = "";
  let pos = 0;
  let img = [];
  let imgTypeArr = [];
  let imgBegin, resultBegin, resultEnd, imgEnd, imgEnd1;
  let imgType, base, imgAll;
  imgEnd = 0;
  function imageMime(number, img, imgType) {
    return (
      "\r\nContent-Type: image/" +
      imgType +
      '; name="image' +
      number +
      "." +
      imgType +
      '"\r\n' +
      "Content-ID: <image" +
      number +
      "." +
      imgType +
      ">\r\n" +
      "Content-Transfer-Encoding: base64\r\n\r\n" +
      img +
      "\r\n\r\n------=_BOUNDARY_LINE_"
    );
  }

  while (pos !== -1) {
    resultBegin = pos;
    pos = str.indexOf("<img", pos + 1);
    resultEnd = pos;
    let height, width;
    let beg, end;
    if (pos !== -1) {
      beg = str.indexOf("width", pos + 1) + 7;
      end = str.indexOf('"', beg);
      width = beg === 6 ? 0 : str.substring(beg, end);
      beg = str.indexOf("height", pos + 1) + 8;
      end = str.indexOf('"', beg);
      height = beg === 7 ? 0 : str.substring(beg, end);

      base = str.indexOf(";base64", pos + 21);
      imgType = str.substring(base - 3, base);
      imgTypeArr.push(imgType);
      imgEnd1 = imgEnd;
      imgBegin = str.indexOf("base64", pos) + 7;
      imgEnd = str.indexOf('"', imgBegin);
      imgAll = str.indexOf("src=", pos) + 5;

      const img1 = new Image();
      img1.src = str.substring(imgAll, imgEnd);

      if (width === 0 && height === 0) {
        width = img1.width;
        height = img1.height;
      } else if (width === 0 && height !== 0) {
        let px = height.indexOf("px", 0);
        height = px > 1 ? height.substring(0, height.length - 2) : height;
        width = Math.round((img1.widt / img1.height) * Number(height)) + "px";
      } else if (width !== 0 && height === 0) {
        let px = width.indexOf("px", 0);
        width = px > 1 ? width.substring(0, width.length - 2) : width;
        height = Math.round((img1.height / img1.width) * Number(width)) + "px";
      }

      result +=
        str.substring(resultBegin === 0 ? 0 : imgEnd1 + 2, resultEnd) +
        "<img width=" +
        width +
        "px height=" +
        height +
        ' alt="" src="cid:image' +
        img.length.toString() +
        "." +
        imgType +
        '">';
      img.push(str.substring(imgBegin, imgEnd));
      imgEnd = str.indexOf(">", pos) - 1;
    }
  }

  result += str.substring(imgEnd !== undefined && imgEnd !== 0 ? imgEnd + 2 : 0, str.length);

  let mime =
    "MIME-Version: 1.0\r\n" +
    'Content-Type: multipart/related; boundary="----=_BOUNDARY_LINE_"\r\n\r\n' +
    "------=_BOUNDARY_LINE_\r\n" +
    'Content-Type: text/html; charset="utf-8"\r\n' +
    "Content-Transfer-Encoding: base64\r\n\r\n" +
    btoa(utf8.encode(result)) +
    "\r\n\r\n------=_BOUNDARY_LINE_";

  for (let i = 0; i < img.length; i++) {
    mime += imageMime(i, img[i], imgTypeArr[i]);
  }
  mime += "--\r\n";

  return mime;
};

export default function DialogHtml(props) {
  const defaultValueRef = useRef(null);
  const [editorValue, setEditorValue] = useState("");
  const editedMimeValue = useRef(
    'MIME-Version: 1.0\r\nContent-Type: multipart/related; boundary="----=_BOUNDARY_LINE_"\r\n\r\n------=_BOUNDARY_LINE_\r\nContent-Type: text/html; charset="utf-8"\r\nContent-Transfer-Encoding: base64\r\n\r\n \r\n\r\n------=_BOUNDARY_LINE_--\r\n',
  );

  useEffect(() => {
    if (props.htmlInput) {
      const mime = MIMEToHtml(props.htmlInput);
      if (mime !== "") {
        setEditorValue(mime);
      }
    }
  }, []);

  async function InputButton(event, requestId) {
    const { value } = event.target;
    const data = {
      Result: value,
      ...(value === "1" && {
        $content: editedMimeValue.current,
      }),
    };
    const axiosReqConfig = {
      params: {
        requestId,
        wsm: "1",
      },
    };
    const resp = await smetaAxios.post("ResumeRequest", data, axiosReqConfig);
    tokenProcessingTest(resp, { propsId: props.id });
  }

  function MIMEToHtml(mime, win1251) {
    if (!mime.includes("MIME-Version: 1.0") && !mime.includes("Mime-Version: 1.0")) {
      const fixedMime = mime.replaceAll("\r\n", "<br/>").replaceAll("\n", "<br/>");
      return `<p>${fixedMime}</p>`;
    }

    //if (!mime.includes("Content-Transfer-Encoding: base64"))
    /*if (mime.includes("Received: from mailx.krista.ru")) {
      return mailMimeToHtml(mime);
    } else if (mime.includes("<html>")) {
      return Html(mime);
    } else if (mime.includes("Content-Location")) {
      return ContentHtml(mime);
    } else {*/
    let html;
    let pos = 0;
    let img = [];
    let imgTypeArr = [];
    let imgName = [];
    let resultBegin;
    let type;
    let posName;
    let endName;
    let imgMap = new Map();
    let imgExt = new Map();
    var doc = document.createElement("doc");
    if (!mime.includes("-=_BOUNDARY_LINE_")) {
      let win8bit = false;
      if (mime.includes("Content-Transfer-Encoding: 8bit") || mime.includes("<html>") || mime.includes("<HTML>")) {
        if (!mime.includes("Content-Transfer-Encoding: quoted-printable")) {
          win8bit = true;
        }
      }
      /*if (mime.includes("Content-Transfer-Encoding: 8bit")) {
       win8bit = true; 
       let utf8dec = new TextDecoder();
       var winMIME = UnicodeToWin1251(mime);
       var Uint8Arr = Uint8Array.from(winMIME.split("").map(x => x.charCodeAt()));
       mime = utf8dec.decode(Uint8Arr);
      }*/
      html = "<div>Ошибка отображения данных<div>";
      let params = new Map();
      params.set("prefix", "stmport");
      params.set("comand", "EMLToMHT");
      AxiosRequest(true, params, { $content: mime }).then((fixedMime) => {
        if (fixedMime.content && fixedMime.content.includes("-=_BOUNDARY_LINE_"))
          setEditorValue(MIMEToHtml(fixedMime.content, win8bit));
      });
      return "";
      //запрос к серверу на преобразование mime
    } else {
      let utf8decoder;
      if (mime.includes('charset="koi8-r"')) {
        utf8decoder = new TextDecoder("koi8-r");
      } else if (mime.includes('charset="cp1251"')) {
        utf8decoder = new TextDecoder("cp1251");
      } else if (mime.includes('harset="windows-1251"') || win1251) {
        utf8decoder = new TextDecoder("windows-1251");
      } else {
        utf8decoder = new TextDecoder();
      }

      while (pos !== -1) {
        resultBegin = pos;
        pos = mime.indexOf("Content-Transfer-Encoding: base64", pos + 1);
        if (pos !== -1) {
          if (resultBegin === 0) {
            html = mime.substring(pos + 37, mime.indexOf("------=_BOUNDARY_LINE_", pos) - 4);
          } else {
            let buf = mime.substring(pos + 37, mime.indexOf("------=_BOUNDARY_LINE_", pos) - 4);
            img.push(buf);
            type = mime.indexOf(".", pos - 8);
            imgTypeArr.push(mime.substring(type + 1, pos - 3));
            posName = mime.indexOf("<", pos - 70);
            endName = mime.indexOf(">", pos - 70);
            imgMap.set(mime.substring(posName + 1, endName), buf);
            imgExt.set(mime.substring(posName + 1, endName), mime.substring(type + 1, pos - 3));
          }
        }
      }

      try {
        html = atob(html);
        var uint8 = Uint8Array.from(html.split("").map((x) => x.charCodeAt()));
        html = utf8decoder.decode(uint8);
        if (html.includes("Mime-Version: 1.0") || html.includes("MIME-Version: 1.0")) {
          let params = new Map();
          params.set("prefix", "stmport");
          params.set("comand", "EMLToMHT");
          AxiosRequest(true, params, { $content: html }).then((fixedMime) => {
            if (fixedMime.content) setEditorValue(MIMEToHtml(fixedMime.content));
          });
          return "";
          //запрос к серверу на преобразование mime
        }
      } catch (_) {
        html = "<div>Ошибка отображения данных<div>";
      }
    }

    if (img.length == 0) {
      if (html.includes("<html>") || html.includes("<HTML>")) {
        return htmlOnly(html);
      }
    }

    html = html.trim();
    doc.innerHTML = html;
    let title = doc.querySelector("title");
    if (title !== null) {
      var para = document.createElement("div");
      let parent = title.parentNode;
      parent.replaceChild(para, title);
    }
    let i = 0;
    // let w = "";
    // let h = '"';
    let spanList = doc.querySelectorAll("img");
    [...spanList].forEach((el) => {
      let key = el.src.substring(4, el.src.length);
      var para = document.createElement("img");
      if (el.width !== 0) {
        para.width = el.width;
        para.height = el.height;
        para.src = "data:image/" + imgExt.get(key) + ";base64," + imgMap.get(key);
        // para.src = "data:image/" + imgTypeArr[i] + ";base64," + img[i++];
        //para.src ='height='+el.height+' width='+el.width+' data:image/'+imgTypeArr[i]+';base64,'+img[i++];
      } else {
        para.src = "data:image/" + imgExt.get(key) + ";base64," + imgMap.get(key);
      }
      let parent = el.parentNode;
      parent.replaceChild(para, el);
    });
    defaultValueRef.current = doc.innerHTML;
    return doc.innerHTML;
    //}
  }

  function htmlOnly(mime) {
    let pos = 0;
    let end = 0;
    let html = "";
    pos = mime.indexOf("<html>");
    if (pos == -1) {
      pos = mime.indexOf("<HTML>");
    }
    end = mime.indexOf("</html>");
    if (end == -1) {
      end = mime.indexOf("</HTML>");
    }
    html = mime.substring(pos, end + 7);
    return html;
  }

  const handleChanges = (val) => {
    setEditorValue(val);
    if (defaultValueRef.current === val) return;
    const mime = htmlToMime(val);
    editedMimeValue.current = mime;
    if (!props.onBlur) return;
    props.onBlur(mime);
  };

  const handleOnChange = (htmlVal, textVal) => {
    if (defaultValueRef.current == htmlVal) return;
    const mime = htmlToMime(htmlVal);
    editedMimeValue.current = mime;
    if (!props.onChange) return;
    props.onChange(mime, textVal || mime);
  };
  return (
    <div style={{ height: "100%" }}>
      <TextEditor
        inputValue={editorValue}
        setInputValue={handleOnChange}
        setValue={handleChanges}
        onPostRecord={props.onPostRecord}
        height={props.HiddenButton ? "0px" : "35px"}
        readonly={props.readonly}
        docId={props.docId}
        onSave={props.onSave}
        linksEnabled={props.linksEnabled}
      />
      {!props.HiddenButton ? (
        <Box
          style={{
            marginLeft: "auto",
            width: "100%",
            height: "35px",
            justifyContent: "flex-end",
            display: "flex",
          }}
        >
          <Button
            size="small"
            variant="outlined"
            value={1}
            onClick={(e) => InputButton(e, props.RequestID)}
            style={{ textTransform: "none" }}
            className="button_Modal_Select"
          >
            Выбрать
          </Button>
          <Button
            size="small"
            variant="outlined"
            onClick={(e) => InputButton(e, props.RequestID)}
            style={{ textTransform: "none", marginLeft: 10 }}
            className="button_Modal_Close"
          >
            Отмена
          </Button>
        </Box>
      ) : null}
    </div>
  );
}
